import LegalLayout from "@/components/LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout
      title="Cookie Policy — LKTH LTD"
      description="The cookies LKTH LTD uses on this website, what they do, and how you can control them under UK GDPR and PECR."
      updated="January 2026"
      testid="cookie-policy-page"
    >
      <p>
        This policy explains how LKTH LTD uses cookies on this website and how you can control
        them, in line with UK GDPR and the Privacy and Electronic Communications Regulations (PECR).
      </p>

      <h2>1. What are cookies?</h2>
      <p>
        Cookies are small text files placed on your device when you visit a website. They are
        widely used to make websites work, remember preferences and provide information to the site
        owner.
      </p>

      <h2>2. Cookies we use</h2>
      <h3 className="mt-6 font-display text-base font-semibold text-[#0B1F3A]">Strictly necessary cookies</h3>
      <ul>
        <li><strong>lkth_cookie_consent</strong> — stores your cookie preferences so we do not ask you again. Duration: up to 12 months. This cookie is set on your device only and contains no personal data.</li>
        <li>Session cookies used by our admin area (authenticated staff only) to keep administrators signed in securely.</li>
      </ul>
      <h3 className="mt-6 font-display text-base font-semibold text-[#0B1F3A]">Optional analytics cookies</h3>
      <ul>
        <li>
          With your consent, we may use privacy-respecting analytics to count page views and
          understand which content is useful. These cookies are set <em>only</em> if you select
          "Accept all" in our consent banner, and can be withdrawn at any time by clearing your
          browser cookies.
        </li>
      </ul>

      <h2>3. Managing your preferences</h2>
      <p>
        When you first visit, our cookie banner lets you "Accept all" or "Decline optional". Your
        choice is stored on your device. You can also block or delete cookies through your browser
        settings at any time — see the help pages for Chrome, Safari, Edge or Firefox. Restricting
        strictly necessary cookies may affect how parts of the website function.
      </p>

      <h2>4. Third-party content</h2>
      <p>
        Our contact page embeds a Google Map of our office. Google may set cookies when the map
        loads; you can review Google's privacy policy on their website. If you prefer not to load
        the map, you can use the address shown beside it instead.
      </p>

      <h2>5. Contact</h2>
      <p>
        Questions about cookies: <a href="mailto:Lateshkatravath3366@gmail.com">Lateshkatravath3366@gmail.com</a>.
      </p>
    </LegalLayout>
  );
}
